export enum FOLD_STATE {
    NAME,
    BASIC_INFO,
    FULL,
}

export enum ICONS {
    PYTHON = "python",
    REACT = "react",
}
export type Icon = typeof ICONS[keyof typeof ICONS];

export type Asset = {
    name: string;
    path: string;
}

export type Project = {
    key: string;
    name: string;
    tagline: string;
    fullDescription: string;
    icons: Icon[];
    assets: Asset[];
};

export type ProjectMap = {
    [projectKey: string]: Project;
};

export type FilteredProjectMap = {
    [projectKey: string]: boolean;
};